<template>
  <!-- && item.isShow === 1 && pcList && pcList.length > 0 -->
  <div v-if="item" class="mode4-box relative" :class="IsMobile ? 'mode_mobile' : ''">
    <div v-if="!(list.length === 0)" class="relative new-mode-header" :class="titleAlignmentClass">
      <el-skeleton :loading="skeletonLoading" animated :throttle="0">
        <template slot="template">
          <el-skeleton-item variant="text" style="width: 150px; height: 24px; margin-left: -35px" />
        </template>
        <div>
          <div class="title-left">
            <img
              class="title-icon"
              v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.icon"
              :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.icon)"
              alt
            />
            <span class="title">{{ $utils.lang_data(lang, item.list[0] && item.list[0], "langInfoObj")?.title }}</span>
          </div>
          <!-- 副标题 -->
          <div class="title_sub" v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.subTitle">
            {{ $utils.lang_data(lang, item.list[0] && item.list[0], "langInfoObj")?.subTitle || "" }}
          </div>
        </div>
      </el-skeleton>
      <div
        v-if="!skeletonLoading"
        class="mode-all title-center-more"
        @click="handleClick(item)"
        v-exposure="{ eid: `101_0_${curindex}_132` }"
        :data-id="`101_0_${curindex}_132`"
      >
        <span>{{ $t("Datalang.HomePage_TYPE_all") }}</span>
        <i class="el-icon-arrow-right pl5"></i>
      </div>
    </div>
    <el-row :gutter="IsMobile ? 10 : 20">
      <el-col :span="IsMobile ? 13 : 12">
        <img
          class="promoteImage"
          style="width: 100%"
          v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.promoteImage && !$utils.isMp4($utils.lang_data(lang, item.list[0], 'langInfoObj')?.promoteImage)"
          :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.promoteImage)"
          alt
        />
        <div class="promoteImage" v-if="$utils.isMp4($utils.lang_data(lang, item.list[0], 'langInfoObj')?.promoteImage)">
          <img
            class="preloadImg"
            style="width: 100%"
            v-if="showPoster"
            :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.preloadImg)"
            alt
          />
          <video
            autoplay
            muted
            loop
            playsinline
            id='background-video'
            class="background-video"
            style="width: 100%;"
            v-show="!showPoster"
            @canplay="showPoster = false;"
          >
            <source :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.promoteImage)" type="video/mp4" />
          </video>
        </div>
      </el-col>
      <el-col :span="IsMobile ? 11 : 12">
        <div class="hot-content" style="overflow: hidden">
          <div class="p-hot-box content" :class="`content_${content_index}`">
            <template v-for="(item, i) in list">
              <div
                class="img-box"
                v-if="hidegd(item)"
                :key="'pc_' + i"
                :class="{ 'mr-0': (i + 1) % curNum === 0 }"
                :style="{
                  width: (IsMobile ? 96 : 91) / curNum + '%',
                  marginRight: (IsMobile ? 4 : 9) / (curNum - 1) + '%',
                }"
              >
                <gameItem :item="item" :target="target" :key="'game_' + i" :skeletonLoading="skeletonLoading" />
              </div>
            </template>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import mode16 from "@/lobby_common/mixins_views/homeModule/mode16.js";
export default {
  mixins: [mode16],
};
</script>
<style lang="scss" scoped>
.title-center-more {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.pl5 {
  padding-left: 5px;
}
// .mode-all {
//   box-sizing: border-box;
//   height: 28px;
//   line-height: 28px;
//   padding: 0 10px;
//   cursor: pointer;
//   color: var(--font-color-200);
//   background: var(--button-1200);
//   box-shadow: var(--boxShadow-1200);
//   border-radius: var(--radius-200);
//   transition: background ease 0.3s;
// }

// .mode-all:hover {
//   background: var(--button-1201);
// }

// .mode-all_style2 {
//   display: inline-block;
//   box-sizing: border-box;
//   height: 28px;
//   line-height: 28px;
//   padding: 0 10px;
//   cursor: pointer;
//   color: var(--font-color-200);
//   background: var(--button-1200);
//   box-shadow: var(--boxShadow-1200);
//   border-radius: var(--radius-200);
//   transition: background ease 0.3s;
//   @media (max-width: 768px) {
//     font-size: 13px;
//   }
// }

// .mode-all_style2:hover {
//   background: var(--button-1201);
// }

.content {
  position: relative;
  // display: flex;
  line-height: 0;
}

.el-icon-arrow-left.custom {
  width: 30px;
  position: absolute;
  right: 40px;
  top: 22px;
  cursor: pointer;
  z-index: 1;
  border-radius: var(--radius-200);
}

.el-icon-arrow-right.custom {
  width: 30px;
  position: absolute;
  right: 0px;
  top: 22px;
  cursor: pointer;
  z-index: 1;
  border-radius: var(--radius-200);
}

.hot-content {
  overflow: hidden;
}
// .p-hot-box.content {
//   display: flex;
// }
.p-hot-box {
  // overflow: hidden;
  position: relative;
  // display: flex;

  .img-box {
    position: relative;
    display: inline-block;
    width: 15%;
    // margin: 0 auto;
    padding-top: 16px;
    margin-right: 2%;
    cursor: pointer;
    transition: 0.5s;
    flex-shrink: 0;
    @media (max-width: 768px) {
      padding-top: 12px;
    }

    &.h5-box {
      width: 30%;
      margin-right: 4%;

      & > .txt {
        font-size: 14px;
        height: 42px;
        line-height: 42px;
      }

      &.more-box {
        position: relative;

        & > .txts {
          position: absolute;
          top: 35%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    &.mr-0 {
      margin-right: 0 !important;
    }

    &:last-child {
      margin-right: 0;
    }

    .txt {
      text-align: center;
      height: 36px;
      line-height: 36px;
    }

    .tubiao {
      position: absolute;
      right: 0px;
      width: 40px;
      height: 35px;
      top: 0px;
      box-sizing: border-box;
      z-index: 999;
    }
  }
}

.more-btn-box {
  width: 100%;
  padding: 10px 0;
  text-align: center;
  .more-btn {
    // width: 150px;
    display: inline-block;
    padding: 0 15px;
    height: 32px;
    line-height: 32px;
    background-color: var(--background-1400);
    margin: 0 auto;
    border-radius: var(--radius-200);
    margin-bottom: 16px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    color: var(--font-color-100);
  }
}
.mode_mobile {
  padding: 0 12px 0px;
}
.promoteImage {
  padding-top: 16px;
  @media (max-width: 768px) {
    padding-top: 12px;
  }
}
</style>
<style lang="scss">
.item-img-skeleton {
  position: relative;
  width: 100%;
  max-width: 300px;
  border-radius: var(--radius-300) !important;
  @media (max-width: 768px) {
    border-radius: var(--radius-301) !important;
  }
}
</style>
